import { Radio } from "antd";

export const loanTypes = {
  NEW: "N",
  RENEWAL: "R",
  CHANGE: "C",
};

export const loanCalculationMethod = {
  FLAT: 0,
  DECLINING: 1,
};

export const loanTypeOptions = [
  {
    value: loanTypes.NEW,
    label: 'New Loan Application',
  },
  {
    value: loanTypes.RENEWAL,
    label: 'Loan Renewal',
  },
  {
    value: loanTypes.CHANGE,
    label: 'Mid-Term Change',
  },
];

export const loanTypeOptionsLimited = [
  {
    value: loanTypes.NEW,
    label: 'New Loan Application',
  },
  {
    value: loanTypes.RENEWAL,
    label: 'Loan Renewal',
    disabled: true,
  },
  {
    value: loanTypes.CHANGE,
    label: 'Mid-Term Change',
    disabled: true,
  },
];

export const downpaymentOptions = [
  {
    value: 'M',
    label: 'Months',
  },
  {
    value: 'A',
    label: 'Amount',
  },
];

export const insuranceTypeOptions = [
  {
    value: 'P',
    label: 'Personal',
  },
  {
    value: 'C',
    label: 'Commercial',
  },
  {
    value: 'S',
    label: 'Special Risk',
  },
  {
    value: 'M',
    label: 'Marine',
  },
];

export const provinceOptions = [
  { label: "Alberta", value: "Alberta" },
  { label: "British Columbia", value: "British Columbia" },
  { label: "Saskatchewan", value: "Saskatchewan" },
  { label: "Manitoba", value: "Manitoba" },
  { label: "Ontario", value: "Ontario" },
  { label: "Quebec", value: "Quebec" },
  { label: "Nova Scotia", value: "Nova Scotia" },
  { label: "New Brunswick", value: "New Brunswick" },
  { label: "Prince Edward Island", value: "Prince Edward Island" },
  { label: "Newfoundland and Labrador", value: "Newfoundland and Labrador" },
  { label: "Northwest Territories", value: "Northwest Territories" },
  { label: "Yukon", value: "Yukon" },
  { label: "Nunavut", value: "Nunavut" },
];
